import React, { Component } from 'react';
import { formatToINR } from 'Utils/transform';

export const RFQOtherTripsTable = ({lineItem}) => {
    return <div>
        <div className="flex flex-row flex-between">
            <span className="section-sub-header-color fBold fs-16">
                Trip
            </span>
            {!lineItem.hideCeilingPrice && <span className="section-sub-header-color fBold fs-16">
                <span className="fRegular fs-16 mr-5">Total Price </span> <span> { formatToINR(lineItem.totalPrice || 0) } </span>
            </span>}
        </div>
        <div className="flex pv-20 border-bottom-light flex-between flex-middle" >
            <div className="flex col-3">
                <span className="section-sub-header-color fBold fs-14 op-5">
                    From
                </span>
            </div>
            <div className="flex col-3">
                <span className="section-sub-header-color fBold fs-14 op-5">
                    To
                </span>
            </div>
            <div className="flex col-3">
                <span className="section-sub-header-color fBold fs-14 op-5">
                    Slabs
                </span>
            </div>
        </div>
        {
            lineItem.lclStops.map((stop, index) => {
                return <div className="flex pv-20 border-bottom-light flex-between flex-middle" key={index}>
                    <div className="flex col-3 flex-column">
                        <span className="section-sub-header-color  fs-14">
                            {stop.from.location}
                        </span>
                        <span className="section-sub-header-color  fs-12">
                            {stop.fromLandmark}
                        </span>
                    </div>
                    <div className="flex col-3 flex-column">
                        <span className="section-sub-header-color  fs-14">
                            {stop.to.location}
                        </span>
                        <span className="section-sub-header-color  fs-12">
                            {stop.fromLandmark}
                        </span>
                    </div>
                    <div className="flex col-3 flex-column">
                        {
                            stop.slabs.map((slab, index) => {
                                return <span className="section-sub-header-color fs-14" key={index}>
                                   {formatToINR(parseInt(slab.expectingPrice))}, {slab.slabTypeName} {slab.unitName}
                                </span>
                            })
                        }
                        {
                            stop.slabs.length == 0 && <span> - </span>
                        }
                    </div>
                </div>
            })
        }
    </div>
}